// 未ログインユーザーが選んだ新卒/中途区分の一時保存（sessionStorage）。
// 既存の guestProfile と同じく sessionStorage を使い、登録・ログイン成功時に
// プロフィール区分（PATCH /api/v1/users/me の profile.career_stage）へ引き継ぐ。

export type CareerStageValue = "new_grad" | "mid_career" | "high_school";

export const GUEST_CAREER_STAGE_KEY = "guestCareerStage";

// new_grad / mid_career の2値の表示ラベル。UI 上は「練習タイプ」と呼び、
// 人事用語の新卒／中途ではなくユーザー自身の行動語（就活／転職）で見せる。
export const CAREER_STAGE_LABELS: Record<CareerStageValue, string> = {
  new_grad: "就活",
  mid_career: "転職",
  high_school: "高校生",
};

export function isCareerStageValue(value: unknown): value is CareerStageValue {
  return value === "new_grad" || value === "mid_career" || value === "high_school";
}

// sessionStorage から一時保存された区分を取得する。無効値・未設定は null。
export function getGuestCareerStage(): CareerStageValue | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(GUEST_CAREER_STAGE_KEY);
    return isCareerStageValue(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function setGuestCareerStage(stage: CareerStageValue): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(GUEST_CAREER_STAGE_KEY, stage);
  } catch {
    // 保存不可（プライベートモード等）でも選択自体は継続できるよう握りつぶす
  }
}

export function clearGuestCareerStage(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(GUEST_CAREER_STAGE_KEY);
  } catch {
    // no-op
  }
}
